<ng-container *ngIf="activeLang">
    <!-- Button -->
    <div class="language-selector-container">
        <div class="language-label" translate>lingueopro.translate.title</div>
        <button class="border" mat-stroked-button [matMenuTriggerFor]="languages">
            <span class="uppercase">{{activeLang.code}}</span>
        </button>
    </div>

    <!-- Language menu -->
    <mat-menu [xPosition]="'before'" #languages="matMenu">
        <ng-container *ngFor="let lang of availableLangs; trackBy: trackByFn">
            <button mat-menu-item (click)="setActiveLang(lang)">
                <span class="flex items-center">
                    <span class="ml-3 capitalize" translate>{{ lang.label }}</span>
                </span>
            </button>
        </ng-container>
    </mat-menu>

    <!-- Flag image template -->
    <!-- <ng-template let-lang #flagImage>
        <span class="relative w-6 rounded-full overflow-hidden">
            <span class="absolute "></span>
            <img class="w-6" [src]="getLanguageFlag(lang.code)" [alt]="'Flag image for ' + lang.lalel">
        </span>
    </ng-template> -->
</ng-container>